
import {Button, View } from '@aws-amplify/ui-react';
import React from 'react';
import { Document, Page } from 'react-pdf'
import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;





function PDFViewer(props) {
  const fileUrl = props.file  
  // console.log("File Url", fileUrl)

  const [numPages, setNumPages] = React.useState(null);
  // const [pageNumber, setPageNumber] = React.useState(1);
  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  }


  // Render all pages
  const pages = [];
  for (let i = 1; i <= (numPages || 0); i++) {
  pages.push(
    <Page
    key={`page_${i}`}
    pageNumber={i}
    renderTextLayer={false}
    renderAnnotationLayer={false}
    width="600"
    // scale=""
    className="mb-5 "
    />
    );
  }

 
  
  return (
    
  
      <View className=" relative flex flex-col justify-center px-9  bg-[rgba(74,77,77,0.3)] overflow-scroll">
      

      {/* <View className='py-5'>
        <text className=' font-semibold'>
        Page {pageNumber} of {numPages}
        </text>
      </View> */}

      <View className='relative flex pb-5 pt-7  '>
        <Button border="transparent" className='SignInUp' onClick={() => window.open(fileUrl, '_blank', 'noopener,noreferrer')}>
            More PDF options
        </Button>
        {/* <a href={fileUrl}>Download the PDF</a> */}
      </View>

      

      <Document file={fileUrl} onLoadSuccess={onDocumentLoadSuccess}>
        
       {numPages ? pages : '' } 
      
      </Document>

     
      

    {/* <object data={fileUrl} type="application/pdf" width="800px" height="600px">
    <p>Your browser does not support PDFs. <a href={fileUrl}>Download the PDF</a>.</p>
    </object> */}


    {/* <iframe
     title="PDF View"
     src={fileUrl}
     height={700}
     width={800}
    //  allow="fullscreen"
    //  frameborder="0"
    >
    </iframe> */}


   </View> 



  
   
  
  );
}

export default PDFViewer;